import React from "react";

export const handleFieldChange = ({
    e,
    onChange,
    hasError
}: {
    e: React.ChangeEvent<HTMLInputElement>;
    onChange: (value: string, hasError?: boolean) => void;
    hasError?: boolean;
}) => {
    const { value } = e.target;
    onChange(value, hasError);
};
